import { Component } from '@angular/core';
import { LandingStartBookingComponent } from "../../shared/start-booking/start-booking.component";
import { ZoomOnScrollDirective } from '../../../../shared/directives/zoom-on-scroll.directive';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'landing-why-us',
    imports: [LandingStartBookingComponent, ZoomOnScrollDirective],
    templateUrl: './why-us.component.html',
    styleUrl: './why-us.component.scss'
})
export class LandingWhyUsComponent {
    assetUrl = environment.assetBaseUrl
}
